<template>
    <productList :readOnly='true'
        ref="productList" />
</template>

<script>

import productList from '@/view/product-management/product-management/product-list';

export default {
    name: 'infoProductList',
    components: {
        productList
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>
